import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import TopMenu from "../Layout/TopMenu";
import { MDBRow, MDBCol } from "mdbreact";
import { IoSearch } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import { FiCopy, FiSearch } from "react-icons/fi";

class MobileFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <div
          style={{
            borderTop: "0.04px solid #202020",
            paddingBottom: 20,
            width: "100vw",
            marginTop: 0,
            paddingTop: 60,
            backgroundColor: "black",
          }}
          className="HeroSection"
        >
          <MDBRow style={{ width: "100vw", backgroundColor: "black" }}>
            <MDBCol style={{ paddingLeft: "10%" }} size="6">
              <p
                style={{
                  color: "white",
                  fontFamily: "PlusJSExtraBold",
                  fontWeight: "600",
                  marginTop: 0,
                  fontSize: 16,
                  marginLeft: "5.5%",
                  color: "white",
                }}
              >
                Product
              </p>
              <NavLink to="/" exact>
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -8,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  Home
                </p>
              </NavLink>
              <NavLink to="/pricing" exact>
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -7,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  Pricing
                </p>
              </NavLink>
              <a href="https://app.youdub.me" target="_blank">
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -7,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  Login
                </p>
              </a>
            </MDBCol>
            <MDBCol style={{ paddingLeft: "10%" }} size="6">
              <p
                style={{
                  color: "white",
                  fontFamily: "PlusJSExtraBold",
                  fontWeight: "600",
                  marginTop: 0,
                  fontSize: 16,
                  marginLeft: "5.5%",
                  color: "white",
                }}
              >
                Company
              </p>
              <NavLink to="/about" exact>
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -8,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  About
                </p>
              </NavLink>
              <NavLink to="/careers" exact>
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -7,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  Careers
                </p>
              </NavLink>
              <a href="" exact>
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -7,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  Book a Demo
                </p>
              </a>
            </MDBCol>
            <MDBCol style={{ paddingLeft: "10%" }} size="6">
              <p
                style={{
                  color: "white",
                  fontFamily: "PlusJSExtraBold",
                  fontWeight: "600",
                  marginTop: 30,
                  fontSize: 16,
                  marginLeft: "5.5%",
                  color: "white",
                }}
              >
                Support
              </p>
              <a href="mailto:help@youdub.me" exact>
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontWeight: "500",
                    marginTop: -8,
                    fontSize: 15,
                    marginLeft: "5.5%",
                    color: "white",
                    color: "white",
                    opacity: 0.6,
                  }}
                >
                  Contact us
                </p>
              </a>
            </MDBCol>
            {/* <MDBCol size="12">
                            <p style={{ fontFamily: "Grifter", fontWeight: "600", marginTop: 30, fontSize: 20, marginLeft: "5.5%", color: "black" }}>Find us on Facebook</p>
                            <a target="_blank" href="https://www.facebook.com/Wornandsold-115520131133526">
                                <img src={require("./facebookImage.png")} style={{ height: 40, width: "auto", marginLeft: "5.5%", marginTop: 0 }} />

                            </a>


                        </MDBCol> */}
            <MDBCol style={{ marginTop: 40, paddingLeft: "10%" }} size="12">
              <p
                style={{
                  display: "inline-block",
                  color: "white",
                  fontFamily: "PlusJSMedium",
                  fontWeight: "500",
                  fontSize: 15,
                  opacity: 0.8,
                }}
              >
                © 2023 YouDub Inc. All rights reserved.
              </p>
            </MDBCol>
          </MDBRow>
        </div>
      </>
    );
  }
}

export default MobileFooter;
